import React, { useState } from 'react';
import axios from 'axios';
import './ContactForm.css'; // Assuming your provided CSS is stored in this file
import Carousel from '../Carousel/Carousel';
import Typewriter from '../Home Page/TypewriteText';
import SelfEmployedDriver from './Role';
const UserInformationForm = () => {
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

    
      const validateVehicleRegistration = (reg) => {
        const ukRegExp = /^[A-Z]{2}[0-9]{2}\s?[A-Z]{3}$/; // UK format: two letters, two numbers, three letters
        return ukRegExp.test(reg);
      };
      const [errors, setErrors] = useState({
        email: '',
        vehicleRegistration: '',
      });
    
      const [snackbar, setSnackbar] = useState({
        open: false,
        message: '',
        severity: 'success',
      });
        
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    mobileNumber: '',
    emailAddress: '',
    townCity: '',
    niNumber: '',
    drivingLicenceNumber: '',
    drivingLicenceShareCode: '',
    fullLicenceCheck: false,
    permissionToShare: '',
    availableOvernight: '',
    offRoadParking: false,
  });

  

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    // Validate email
    

    

    try {
      // Send form data to the backend
      const response = await axios.post('https://zoomautos.co.uk/car', {
        formType: 'DriverForm',
        ...formData,
      });
      console.log('Form submitted successfully:', response.data);

      // Reset form data after successful submission
      setFormData({
        firstName: '',
    lastName: '',
    mobileNumber: '',
    emailAddress: '',
    townCity: '',
    
    drivingLicenceNumber: '',
    drivingLicenceShareCode: '',
    fullLicenceCheck: false,
    permissionToShare: '',
    availableOvernight: '',
    offRoadParking: false,
      });

      // Reset errors
      setErrors({ email: '', vehicleRegistration: '' });

      // Show success message
      setSnackbar({ open: true, message: 'Form submitted successfully!', severity: 'success' });
    } catch (error) {
      console.error('Error submitting form:', error.response ? error.response.data : error.message);
      // Show error message
      setSnackbar({ open: true, message: 'Error submitting form. Please try again.', severity: 'error' });
    }
    setLoading(false);
    setSuccess(true);

    // Hide success overlay after 2 seconds
    setTimeout(() => {
      setSuccess(false);
    }, 2000);
  };
  const validateDateTime = () => {
    const { fromDate, fromTime, toDate, toTime } = formData;

    if (fromDate && toDate) {
      // Check if the toDate is earlier than fromDate
      if (new Date(toDate) < new Date(fromDate)) {
        document.getElementById('toDate').setCustomValidity('To Date must be after From Date');
      } else if (fromDate === toDate && fromTime && toTime) {
        // If the dates are the same, check if toTime is earlier than fromTime
        if (toTime <= fromTime) {
          document.getElementById('toTime').setCustomValidity('To Time must be after From Time');
        } else {
          document.getElementById('toTime').setCustomValidity('');
        }
      } else {
        document.getElementById('toDate').setCustomValidity('');
        document.getElementById('toTime').setCustomValidity('');
      }
    }
  };
  const imagesW = [
    { image:  "/Driver1.jpg"},
    { image: "/Driver 2.jpg"},
    
  ];
  return (
    <>
    <Carousel imagesWithText={imagesW}/>
    <div className='overlay-text'>
      <h1>Welcome To Zoom Autos</h1>
      
    <h2 style={{color:'Red'}}>Work For US</h2>
    
    </div>
    <div style={{marginTop:'-10px'}}>
    <SelfEmployedDriver/>
    </div>
    <form onSubmit={handleSubmit}>
    <h1>Register Yourself As a Driver</h1>
        <div className="driver-container">
      
      <div className="mve-form">
      
    
      <h2>Driver Information</h2>
      <div className="form-row">
          
      <div className="form-group">
        <label htmlFor="firstName">First Name:</label>
        <input
          type="text"
          id="firstName"
          name="firstName"
          value={formData.firstName}
          onChange={handleChange}
          required
        />
      </div>

      <div className="form-group">
        <label htmlFor="lastName">Last Name:</label>
        <input
          type="text"
          id="lastName"
          name="lastName"
          value={formData.lastName}
          onChange={handleChange}
          required
        />
      </div>
</div>
<div className='form-row'>
      <div className="form-group">
        <label htmlFor="mobileNumber">Mobile Number:</label>
        <input
          type="tel"
          id="mobileNumber"
          name="mobileNumber"
          value={formData.mobileNumber}
          onChange={handleChange}
          required
        />
      </div>
      
      
      <div className="form-group">
        <label htmlFor="emailAddress">Email Address:</label>
        <input
          type="email"
          id="emailAddress"
          name="emailAddress"
          value={formData.emailAddress}
          onChange={handleChange}
          required
        />
      </div>
      </div>

      <div className="form-row">
      <div className="form-group">
        <label htmlFor="townCity">Town or City:</label>
        <input
          type="text"
          id="townCity"
          name="townCity"
          value={formData.townCity}
          onChange={handleChange}
          required
        />
      </div>

      <div className="form-group">
        <label htmlFor="Insurance">Insurance Number</label>
        <input
          type="text"
          id="Insurance"
          name="Insurance"
          value={formData.Insurance}
          onChange={handleChange}
          required
        />
      </div>

      
      </div>
      <div className='form-row'>
      <div className="form-group">
        <label htmlFor="drivingLicenceNumber">Driving Licence Number:</label>
        <input
          type="text"
          id="drivingLicenceNumber"
          name="drivingLicenceNumber"
          value={formData.drivingLicenceNumber}
          onChange={handleChange}
          required
        />
      </div>

      <div className="form-group">
        <label htmlFor="drivingLicenceShareCode">Driving Licence Share Code:</label>
        <input
          type="text"
          id="drivingLicenceShareCode"
          name="drivingLicenceShareCode"
          value={formData.drivingLicenceShareCode}
          onChange={handleChange}
          required
        />
        </div>
        </div>
        <small>
          To access your driving licence share code{' '}
          <a href="https://www.gov.uk/view-driving-licence" target="_blank" rel="noopener noreferrer" style={{fontSize:'1rem'}}>
            click here
          </a>
        </small>
      

      <div className="form-group">
        <label htmlFor="fullLicenceCheck">Full Licence Check:</label>
        <input
          type="checkbox"
          id="fullLicenceCheck"
          name="fullLicenceCheck"
          checked={formData.fullLicenceCheck}
          onChange={handleChange}
        />
        <span>
          I hereby give my permission for Zoom Autos to conduct a full check of my driving licence as and when required.
        </span>
      </div>
      <div className='form-section'>
<h3>Permission to Share Mobile Number:</h3>    

      <div className="form-row">
      <div className='radiocontainer'>

        <label>
          <input
            type="radio"
            id="yesShare"
            name="permissionToShare"
            value="Yes"
            checked={formData.permissionToShare === 'Yes'}
            onChange={handleChange}
            required
          />
          <span>Yes</span>
          </label>

        
        <label>
          <input
            type="radio"
            id="noShare"
            name="permissionToShare"
            value="No"
            checked={formData.permissionToShare === 'No'}
            onChange={handleChange}
            required
          />
          <span>No</span>
          </label>
      </div>
      </div>
<h3>Available to Stay Overnight?</h3>
      <div className="form-row">
        <div className='radiocontainer'>
        <label >
        
          <input
            type="radio"
            id="yesOvernight"
            name="availableOvernight"
            value="Yes"
            checked={formData.availableOvernight === 'Yes'}
            onChange={handleChange}
            required
          />
          <span >Yes</span>
          </label>
        
        <label >
          <input
            type="radio"
            id="noOvernight"
            name="availableOvernight"
            value="No"
            checked={formData.availableOvernight === 'No'}
            onChange={handleChange}
            required
          />
          <span>No</span>
          </label>
        </div>
        
      </div>
      </div>

      
      <div className="form-group" style={{ display: 'flex', alignItems: 'center' }}>
  <label htmlFor="offRoadParking" style={{ marginRight: '10px' }}>Do you have space for offRoadParking?</label>
  <input
    type="checkbox"
    id="offRoadParking"
    name="offRoadParking"
    checked={formData.offRoadParking}
    onChange={handleChange}
  />
</div>


      <button type="submit" className='contact-button'>Submit</button>
    
      </div>
    </div>
    </form>
    {loading && (
        <div className='overlayStyle'>
          <div className='loadingStyle'  >Submitting...</div>
        </div>
      )}

      {/* Success Overlay */}
      {success && (
        <div className='overlayStyle'>
          <div className='successStyle' >Thanks for Joining us, we will Contact you Soon!</div>
        </div>
      )}
    </>
  );
};

export default UserInformationForm;
